import { DetailHeader } from "../../../components/detailHeader/DetailHeader";
import { Box, IconButton, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { useContext } from "react";
import { RecordContext } from "../../../components/record/Record";
import { OpenInNew } from "@mui/icons-material";
import { SessionActionButtons } from "./SessionActionButtons";
import { useFields } from "../../../api/useFields";
import { findField } from "../../../utils/findField";
import { CustomChip } from "../../../components/chips/CustomChip";
import { Avatar } from "../../../components/fieldsViews/fields/Avatar";
import { formatDateWithTime } from "../../../utils/dateUtils";

export const SessionHeader = () => {
    const recordContext = useContext(RecordContext);

    if (!recordContext) return null;

    return (
        <DetailHeader collection={recordContext.collection}>
            <SessionHeaderData session={recordContext.item} />
        </DetailHeader>
    );
};

type SessionHeaderDataProps = {
    session: any;
    hasNote?: boolean;
};

export const SessionHeaderData = ({ session, hasNote }: SessionHeaderDataProps) => {
    const { formatedFields } = useFields("sessions");
    const statusField = findField(formatedFields, "status");

    const { treatment, service } = session;
    const client = treatment?.client;
    const treatmentLink = `/treatments/${treatment?.id}/detail`;
    const technician = session?.technician?.user_id;
    const dateLabel = formatDateWithTime(session?.start_date);

    return (
        <Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Typography variant="h6" color="secondary">{service?.name}</Typography>
                <SessionActionButtons session={session} hasNote={hasNote} />
			</Box>
			<Grid container alignItems="flex-start" display="flex" flexWrap="nowrap" flexDirection="row" gap={5} mt={2}>
					{treatmentLink && client &&
                <Grid>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                            variant="h6"
                            color="primary"
                            component={Link}
                            sx={{ textDecoration: "none" }}
                            to={treatmentLink}
                        >
                            {client?.client_id}
                        </Typography>
							{treatment?.id &&
                        <IconButton sx={{ ml: 2, p: 0 }} color="primary" component={Link} to={treatmentLink} target="_blank">
                            <OpenInNew />
                        </IconButton>
                        }
                    </Box>
                    <Typography variant="body1">{client?.user_id?.first_name}</Typography>
                </Grid>
            }
                <Box>
                    <Typography variant="h6" color="primary">Data</Typography>
                    <Typography variant="body1">{dateLabel}</Typography>
                </Box>

                {statusField && session?.status && (
                    <Box>
                        <Typography variant="h6" color="primary">Estado</Typography>
                        <CustomChip field={statusField} label={session.status} />
                    </Box>
                )}
                {technician && (
                    <Box>
                        <Typography variant="h6" color="primary">Técnico</Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Avatar value={technician?.avatar} styles={{ width: 25, height: 25 }} />
                            <Typography variant="body1">{technician?.first_name} {technician?.last_name}</Typography>
                        </Box>
                    </Box>
                )}
            </Grid>
        </Box>
    );
};
